enum UserRoles {
  LOREKEEPER = "DDB - Lorekeepers",
  ADMIN = "Admin",
  DEV = "DDB - Devs",
}

export default UserRoles;
